var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.46078 7.261C1.40175 7.09262 1.40175 6.90739 1.46078 6.739C2.03573 5.26289 3.01168 4.00078 4.26491 3.11268C5.51813 2.22457 6.99218 1.75047 8.50019 1.75047C10.0082 1.75047 11.4823 2.22457 12.7355 3.11268C13.9887 4.00078 14.9647 5.26289 15.5396 6.739C15.5986 6.90739 15.5986 7.09262 15.5396 7.261C14.9647 8.73711 13.9887 9.99922 12.7355 10.8873C11.4823 11.7754 10.0082 12.2495 8.50019 12.2495C6.99218 12.2495 5.51813 11.7754 4.26491 10.8873C3.01168 9.99922 2.03573 8.73711 1.46078 7.261Z",
    stroke: "#F5F5F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50019 9.25C9.6738 9.25 10.6252 8.24264 10.6252 7C10.6252 5.75736 9.6738 4.75 8.50019 4.75C7.32659 4.75 6.37519 5.75736 6.37519 7C6.37519 8.24264 7.32659 9.25 8.50019 9.25Z",
    stroke: "#F5F5F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/vector-2.1fb1c654a1c721530a78d59647f7ff70.svg";
export { ForwardRef as ReactComponent };